import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";

import { FilterSideBarLoadingSkeleton } from "@faire/retailer/components/Filters/FilterSideBarLoadingSkeleton";
import { GhostBlock } from "@faire/retailer/components/GhostLoading/GhostBlock";
import { GhostText } from "@faire/retailer/components/GhostLoading/GhostTypography";
import { LoadingProductTileSkeleton } from "@faire/retailer/components/LoadingProductTileSkeleton/LoadingProductTileSkeleton";
import { OuterResultsContentWrapper } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/CategoryPageCommonStyles";
import { HeaderPlaceholder } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/HeaderPlaceholder";

const NUM_TILES = {
  mobile: 4,
  tablet: 12,
  desktopAndAbove: 16,
};
const FILTER_PROPS = {
  $height: "40px",
  $borderRadius: "20px",
  $width: "120px",
};

export const LoggedOutCategoryPageLoadingSkeleton: React.FC = () => {
  return (
    <div data-test-id="logged-out-category-page-loading-skeleton">
      <BreadcrumbPlaceholder>
        <GhostText /> <Spacer width="1x" /> <GhostText />
      </BreadcrumbPlaceholder>
      <ContentContainer>
        {/* filter bar on desktop and above */}
        <ResponsiveContentV2
          desktopAndAbove={<FilterSideBarLoadingSkeleton />}
        />
        <OuterResultsContentWrapper>
          <HeaderPlaceholder />
          <Spacer height={{ mobileAndAbove: "6x", desktopAndAbove: "9x" }} />

          {/* Filters Row on tablet and below*/}
          <ResponsiveContentV2
            tabletAndBelow={
              <FilterRow>
                <GhostBlock {...FILTER_PROPS} />
                <Spacer width="2x" />
                <GhostBlock {...FILTER_PROPS} />
              </FilterRow>
            }
          />
          <Spacer height="2x" />
          {/* Tiles */}
          <TileGrid>
            {Array.from({ length: NUM_TILES["desktopAndAbove"] }).map(
              (_, index) => (
                <LoadingProductTileSkeleton key={index} />
              )
            )}
          </TileGrid>
        </OuterResultsContentWrapper>
      </ContentContainer>
    </div>
  );
};

const TileGrid = styled.div`
  display: grid;
  grid-gap: ${getSpacing("2x")};

  ${responsiveMediaQueries.mobile} {
    grid-template-columns: repeat(2, 2fr);
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    grid-template-columns: repeat(4, 4fr);
  }
`;
const ContentContainer = styled(Row)`
  padding: ${getSpacing("2x", "5x", 0, "5x")};
  height: 100%;
  max-width: 1280px;
  margin: 0 auto;
  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("4x", "2x", 0, "2x")};
  }
`;

const BreadcrumbPlaceholder = styled(Row)`
  padding: 14px 20px;

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 14px 25px;
  }
  ${responsiveMediaQueries.desktopAndAbove} {
    padding: 14px 15px;
  }
  border-bottom: 1px solid ${Core.border.muted};
  max-width: 1700px;
  margin: 0 auto;
`;

const FilterRow = styled(Row)`
  overflow-x: hidden;
`;
